import { render, staticRenderFns } from "./ModalNote.vue?vue&type=template&id=48969ae0&"
import script from "./ModalNote.vue?vue&type=script&lang=js&"
export * from "./ModalNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports